module.exports = __webpack_public_path__ + "static/media/tax.2d90d073.svg";